<template>
    <footer id="footer" :class="{'isVisible' : isVisible}">
        <span v-if="isVisible">Copyright <strong>Effis Tecnologia</strong> © 2020</span>
    </footer>
</template>

<script>

import { mapState } from 'vuex'

export default {
    name: "Footer",
    computed: mapState(['isVisible'])
}
</script>

<style>
    #footer {
        position: absolute;

        bottom: 0;
        width: 100%;
        height: 40px;

        grid-area: footer;
        
        color: #aeaeae !important;

        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding-right: 10px;
    }

    #footer.isVisible {
        background-color: #313177;
    }
</style>
